import React from 'react';
import { number, object } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Control, Experiment, Variant } from '@fiverr-private/fiverr_context';
import { GOATS_GIG_PAGE_STICKY_CTA } from '../../utils/experiments/experimentsEnum';
import SafePureComponent from '../shared/SafePureComponent';
import CheckoutFormHOC from '../shared/CheckoutFormHOC';
import { getPackageById } from '../../reducers/packages';
import { VARIANTS } from '../../types/variants';
import CheckoutCta from '../shared/CheckoutCta';
import ContactSeller from './ContactSeller';

import './style.scss';

const BASE_CLASS = 'mobile-sticky-cta';
const CHECKOUT_BUTTON_SOURCE = 'sticky_cta';
const MAX_ALLOWED_SIZE = 8;

const MobileStickyCta = ({ selectedPackageId, currentPrice, overview, customOrder }, { currencyConverter }) => {
    const formattedPrice = currencyConverter.convert(currentPrice);
    const shrinkChat = formattedPrice.length > MAX_ALLOWED_SIZE;

    return (
        <Experiment test={GOATS_GIG_PAGE_STICKY_CTA} report>
            <Control>
                <span/>
            </Control>
            <Variant v={VARIANTS.B}>
                <div className={classNames(BASE_CLASS, 'contact-seller-and-checkout')}>
                    <ContactSeller variant={VARIANTS.B} overview={overview} customOrder={customOrder} shrinkChat={shrinkChat}/>
                    <CheckoutFormHOC className="sticky-form" selectedPackageId={selectedPackageId} source={CHECKOUT_BUTTON_SOURCE}>
                        <CheckoutCta className="sticky-checkout-btn" price={formattedPrice}/>
                    </CheckoutFormHOC>
                </div>
            </Variant>
            <Variant v={VARIANTS.C}>
                <div className={classNames(BASE_CLASS, 'floating-contact-seller')}>
                    <ContactSeller variant={VARIANTS.C} overview={overview} customOrder={customOrder}/>
                </div>
            </Variant>
        </Experiment>
    );
};

MobileStickyCta.propTypes = {
    selectedPackageId: number,
    currentPrice: number,
    overview: object,
    customOrder: object
};

MobileStickyCta.contextTypes = {
    currencyConverter: object
};

const mapStateToProps = ({ packages }) => {
    const { selectedPackageId } = packages;
    const { currentPrice } = getPackageById(packages, selectedPackageId);

    return {
        selectedPackageId,
        currentPrice
    };
};

export default SafePureComponent(connect(mapStateToProps)(MobileStickyCta));
